var map = {
	"./ico-monitor.png": 1052,
	"./ico-streaming.png": 1053,
	"./noimg.jpg": 1054
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1925;


//////////////////
// WEBPACK FOOTER
// ./src/app/website/pregao-comitente/assets/images ^\.\/.*$
// module id = 1925
// module chunks = 17